import { ReactNode } from "react";
import { styleWithVars } from "@lib/cssVars";
import type { SpreadsheetScrollbarSizes } from "./useSpreadsheetScrollEdges";
import styles from "./SpreadsheetGrid.module.scss";

interface Props {
    footer: ReactNode;
    scrollbarSizes: SpreadsheetScrollbarSizes;
    children: ReactNode;
}

/**
 * Fills its parent with the grid and floats `footer` (a command island) over
 * the grid's bottom edge, clear of its scrollbars. The grid keeps scroll room
 * past its last row so that row can scroll out from under the footer.
 */
export const SpreadsheetFloatingFooterHost = ({
    footer,
    scrollbarSizes,
    children,
}: Props) => (
    <div
        className={styles.floatingFooterHost}
        style={styleWithVars({
            "--spreadsheet-scrollbar-x-h": `${scrollbarSizes.horizontalHeight}px`,
            "--spreadsheet-scrollbar-y-w": `${scrollbarSizes.verticalWidth}px`,
        })}
    >
        {children}
        <div className={styles.floatingFooterSlot}>{footer}</div>
    </div>
);
